import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "price-line" }
const _hoisted_2 = {
  key: 0,
  class: "o-text-caption font-bold xl:-mt-3 whitespace-normal"
}
const _hoisted_3 = { class: "price-line-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.lineItemDiscountPerItem, [_ctx.discount.percentage.toString()])), 1),
      (_ctx.showExpirationDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.expireLabel), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_3, " -" + _toDisplayString(_ctx.discount.discountTotal), 1)
  ]))
}